var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "product-binding-dialog",
          attrs: {
            title: "绑定商品",
            visible: _vm.dialogVisible,
            width: "70%",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: { inline: true, model: _vm.searchForm },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入商品名称",
                          clearable: "",
                          "prefix-icon": "el-icon-search",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearch($event)
                          },
                        },
                        model: {
                          value: _vm.searchForm.keyword,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "keyword", $$v)
                          },
                          expression: "searchForm.keyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择状态", clearable: "" },
                          model: {
                            value: _vm.searchForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "status", $$v)
                            },
                            expression: "searchForm.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: null },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "上架", value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "下架", value: 0 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-container" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "productTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.productList,
                        border: "",
                        stripe: "",
                        "highlight-current-row": "",
                        "header-cell-style": {
                          background: "#f8f8f9",
                          color: "#606266",
                        },
                      },
                      on: { "selection-change": _vm.handleSelectionChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "55",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "id",
                          label: "ID",
                          width: "80",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "商品图片",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.imageList &&
                                scope.row.imageList.length > 0
                                  ? _c(
                                      "el-image",
                                      {
                                        staticStyle: {
                                          width: "60px",
                                          height: "60px",
                                          "border-radius": "4px",
                                        },
                                        attrs: {
                                          src: scope.row.imageList[0],
                                          fit: "cover",
                                          "preview-src-list":
                                            scope.row.imageList,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "image-slot",
                                            attrs: { slot: "error" },
                                            slot: "error",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-picture-outline",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c("div", { staticClass: "no-image" }, [
                                      _c("i", {
                                        staticClass: "el-icon-picture-outline",
                                      }),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productName",
                          label: "商品名称",
                          "min-width": "180",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "product-name" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.productName)),
                                    ]),
                                    _vm._v(" "),
                                    scope.row.tagList &&
                                    scope.row.tagList.length > 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticClass: "product-tag",
                                            attrs: {
                                              size: "mini",
                                              type: "info",
                                              effect: "plain",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(scope.row.tagList[0]) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "price",
                          label: "售价",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", { staticClass: "price" }, [
                                  _vm._v(
                                    "￥" + _vm._s(scope.row.price || "0.00")
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "originalPrice",
                          label: "原价",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", { staticClass: "original-price" }, [
                                  _vm._v(
                                    "￥" +
                                      _vm._s(scope.row.originalPrice || "0.00")
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "supplierName",
                          label: "供应商",
                          width: "150",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "status",
                          label: "状态",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        scope.row.status === 1
                                          ? "success"
                                          : "info",
                                      size: "mini",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.status === 1
                                            ? "上架"
                                            : "下架"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "syncStatus",
                          label: "默认加到诊所",
                          width: "120",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        scope.row.syncStatus === 1
                                          ? "primary"
                                          : "info",
                                      size: "mini",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.syncStatus === 1
                                            ? "是"
                                            : "否"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.searchForm.page,
                      "page-sizes": [10, 20, 30, 50],
                      "page-size": _vm.searchForm.limit,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        return _vm.$set(_vm.searchForm, "page", $event)
                      },
                      "update:current-page": function ($event) {
                        return _vm.$set(_vm.searchForm, "page", $event)
                      },
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.selectedProducts.length === 0,
                  },
                  on: { click: _vm.confirmBinding },
                },
                [
                  _vm._v(
                    "\n        确定绑定 (" +
                      _vm._s(_vm.selectedProducts.length) +
                      ")\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }